/**
 * Every message a client may send. They are *intentions*: the server decides
 * the outcome (CLAUDE.md rule 1). Each type has a zod schema next to it.
 */
export const CLIENT_MESSAGE = {
    MOVE_TO: 'move_to',
    ATTACK: 'attack',
    CAST: 'cast',
    USE_ITEM: 'use_item',
    EQUIP: 'equip',
    SORT_BAG: 'sort_bag',
    DESTROY_ITEM: 'destroy_item',
    MOUNT: 'mount',
    UPGRADE_ITEM: 'upgrade_item',
    REFORGE_ITEM: 'reforge_item',
    SELL_ITEM: 'sell_item',
    BUY_ITEM: 'buy_item',
    FUSE_ITEM: 'fuse_item',
    BREW_POTION: 'brew_potion',
    STASH_OPEN: 'stash_open',
    STASH_DEPOSIT: 'stash_deposit',
    STASH_WITHDRAW: 'stash_withdraw',
    TUTOR_SKIP: 'tutor_skip',
    USE_PORTAL: 'use_portal',
    TELEPORT: 'teleport',
    SET_RESPAWN: 'set_respawn',
    PROFILE: 'profile',
    ACHIEVEMENTS: 'achievements',
    SET_TITLE: 'set_title',
    CLAIM_ACHIEVEMENT: 'claim_achievement',
    QUESTS: 'quests',
    QUEST_ACCEPT: 'quest_accept',
    QUEST_TALK: 'quest_talk',
    QUEST_TURN_IN: 'quest_turn_in',
    QUEST_ABANDON: 'quest_abandon',
    CONTRACTS: 'contracts',
    CONTRACT_CLAIM: 'contract_claim',
    ADMIN_COMMAND: 'admin_command',
    CHAT: 'chat',
    PARTY_INVITE: 'party_invite',
    PARTY_ANSWER: 'party_answer',
    PARTY_LEAVE: 'party_leave',
    PARTY_KICK: 'party_kick',
    FRIEND_REQUEST: 'friend_request',
    FRIEND_ANSWER: 'friend_answer',
    FRIEND_REMOVE: 'friend_remove',
    BLOCK_PLAYER: 'block_player',
    UNBLOCK_PLAYER: 'unblock_player',
    TRADE_REQUEST: 'trade_request',
    TRADE_ANSWER: 'trade_answer',
    TRADE_OFFER: 'trade_offer',
    TRADE_CONFIRM: 'trade_confirm',
    TRADE_CANCEL: 'trade_cancel',
    GUILD_CREATE: 'guild_create',
    GUILD_INVITE: 'guild_invite',
    GUILD_ANSWER: 'guild_answer',
    GUILD_LEAVE: 'guild_leave',
    GUILD_KICK: 'guild_kick',
    GUILD_RANK: 'guild_rank',
    GUILD_MOTD: 'guild_motd',
    GUILD_DISBAND: 'guild_disband',
    MODERATE: 'moderate',
    REPORT: 'report',
    AERIE_ENTER: 'aerie_enter',
    AERIE_STATUS: 'aerie_status',
    USE_STATION: 'use_station',
    ALLIANCE_INVITE: 'alliance_invite',
    ALLIANCE_ANSWER: 'alliance_answer',
    ALLIANCE_LEAVE: 'alliance_leave',
    SET_AWAY: 'set_away',
    INSPECT: 'inspect',
    PEDDLER_BUY: 'peddler_buy',
    ENCOUNTER_OPEN: 'encounter_open',
    BOUNTIES: 'bounties',
    BOUNTY_TAKE: 'bounty_take',
    BOUNTY_CLAIM: 'bounty_claim',
};
//# sourceMappingURL=message-types.js.map